var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14592 2.46069L13.1827 11.5002L4.14681 20.5396C3.98613 20.4721 3.84901 20.3585 3.75269 20.2133C3.65637 20.068 3.60515 19.8975 3.60547 19.7232V3.27714C3.60554 3.10304 3.65681 2.93281 3.75291 2.78764C3.84901 2.64247 3.98568 2.52877 4.14592 2.46069ZM13.8102 12.1276L15.853 14.1705L6.1471 19.7906L13.8102 12.1276ZM16.6491 9.28955L19.1401 10.7325C19.2746 10.8105 19.3862 10.9225 19.4638 11.0572C19.5414 11.192 19.5823 11.3447 19.5823 11.5002C19.5823 11.6556 19.5414 11.8084 19.4638 11.9431C19.3862 12.0778 19.2746 12.1898 19.1401 12.2678L16.6482 13.7108L14.4376 11.5002L16.6491 9.28955ZM6.1471 3.20969L15.8539 8.82897L13.8102 10.8727L6.1471 3.20969Z",
    fill: "#EBF8DE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.79ad2e16d1c5c7873c8d8d4508aefe2a.svg";
export { ForwardRef as ReactComponent };